export default __webpack_public_path__ + "static/media/element_14.e91d2680.webp";